module.exports = __webpack_public_path__ + "img/3.21e9c695.jpg";